import { connect } from 'react-redux'

import { getFeatureModuleName } from 'selectors/feature/featureMetadata'
import { CHECPLUS_MODULE_TYPES, CHECPLUS_MODULE_NAMES } from 'utils/constants'
import OutputTypeEditor from './OutputTypeEditor'

const { ASAM } = CHECPLUS_MODULE_TYPES

const makeMapStateToProps = () => {
  return (state, ownProps) => {
    const { output, featureModuleType, isDeletable } = ownProps

    const featureModuleName = getFeatureModuleName(state)

    const disableCan = featureModuleType === ASAM && isDeletable

    const isXMC2 = featureModuleName === CHECPLUS_MODULE_NAMES.XMC2

    return {
      output,
      disableCan,
      isXMC2,
    }
  }
}

export default connect(makeMapStateToProps)(OutputTypeEditor)
